var map = {
	"./ac.svg": 6543,
	"./ad.svg": 2752,
	"./ae.svg": 3873,
	"./af.svg": 8834,
	"./ag.svg": 2147,
	"./ai.svg": 6741,
	"./al.svg": 920,
	"./am.svg": 6937,
	"./ao.svg": 6459,
	"./aq.svg": 4797,
	"./ar.svg": 1822,
	"./as.svg": 6463,
	"./at.svg": 8992,
	"./au.svg": 3377,
	"./aw.svg": 3,
	"./ax.svg": 6724,
	"./az.svg": 5846,
	"./ba.svg": 276,
	"./bb.svg": 4871,
	"./bd.svg": 5305,
	"./be.svg": 9800,
	"./bf.svg": 8635,
	"./bg.svg": 3370,
	"./bh.svg": 9117,
	"./bi.svg": 3660,
	"./bj.svg": 2687,
	"./bl.svg": 225,
	"./bm.svg": 9664,
	"./bn.svg": 403,
	"./bo.svg": 9826,
	"./bq.svg": 8036,
	"./br.svg": 9543,
	"./bs.svg": 6,
	"./bt.svg": 3689,
	"./bv.svg": 3307,
	"./bw.svg": 1338,
	"./by.svg": 7420,
	"./bz.svg": 95,
	"./ca.svg": 1099,
	"./cc.svg": 5753,
	"./cd.svg": 5718,
	"./cefta.svg": 2070,
	"./cf.svg": 4980,
	"./cg.svg": 7589,
	"./ch.svg": 3474,
	"./china.svg": 8600,
	"./ci.svg": 8115,
	"./ck.svg": 6609,
	"./cl.svg": 3230,
	"./cm.svg": 6959,
	"./cn.svg": 7932,
	"./co.svg": 7405,
	"./cp.svg": 1818,
	"./cr.svg": 5688,
	"./cu.svg": 7252,
	"./cv.svg": 1748,
	"./cw.svg": 2917,
	"./cx.svg": 8274,
	"./cy.svg": 3443,
	"./cz.svg": 2688,
	"./de.svg": 7254,
	"./dg.svg": 8932,
	"./dj.svg": 4673,
	"./dk.svg": 6224,
	"./dm.svg": 4766,
	"./do.svg": 4668,
	"./dz.svg": 7473,
	"./ea.svg": 4969,
	"./ec.svg": 8299,
	"./ee.svg": 7957,
	"./eg.svg": 4535,
	"./eh.svg": 9328,
	"./er.svg": 1002,
	"./es-ct.svg": 529,
	"./es-ga.svg": 4408,
	"./es.svg": 2971,
	"./et.svg": 7700,
	"./eu.svg": 2629,
	"./fi.svg": 8664,
	"./fj.svg": 6731,
	"./fk.svg": 2858,
	"./fm.svg": 9140,
	"./fo.svg": 8262,
	"./fr.svg": 4563,
	"./french.svg": 4503,
	"./ga.svg": 1383,
	"./gb-eng.svg": 8379,
	"./gb-nir.svg": 8624,
	"./gb-sct.svg": 637,
	"./gb-wls.svg": 2699,
	"./gb.svg": 8260,
	"./gd.svg": 7706,
	"./ge.svg": 411,
	"./germany.svg": 5909,
	"./gf.svg": 1576,
	"./gg.svg": 6441,
	"./gh.svg": 9710,
	"./gi.svg": 4463,
	"./gl.svg": 4162,
	"./gm.svg": 6803,
	"./gn.svg": 2256,
	"./gp.svg": 6406,
	"./gq.svg": 3527,
	"./gr.svg": 2020,
	"./gs.svg": 7653,
	"./gt.svg": 7242,
	"./gu.svg": 5083,
	"./gw.svg": 7993,
	"./gy.svg": 2847,
	"./hk.svg": 7100,
	"./hm.svg": 5938,
	"./hn.svg": 3041,
	"./hr.svg": 6405,
	"./ht.svg": 6123,
	"./hu.svg": 7306,
	"./ic.svg": 775,
	"./id.svg": 968,
	"./ie.svg": 8889,
	"./il.svg": 4208,
	"./im.svg": 6449,
	"./in.svg": 1410,
	"./io.svg": 5699,
	"./iq.svg": 229,
	"./ir.svg": 1094,
	"./is.svg": 8631,
	"./it.svg": 8824,
	"./italy.svg": 3732,
	"./je.svg": 736,
	"./jm.svg": 24,
	"./jo.svg": 394,
	"./jp.svg": 8157,
	"./ke.svg": 655,
	"./kg.svg": 573,
	"./kh.svg": 3898,
	"./ki.svg": 8507,
	"./km.svg": 6951,
	"./kn.svg": 3828,
	"./kp.svg": 5554,
	"./kr.svg": 3152,
	"./kw.svg": 9485,
	"./ky.svg": 3179,
	"./kz.svg": 2440,
	"./la.svg": 9154,
	"./lb.svg": 9553,
	"./lc.svg": 6611,
	"./li.svg": 2698,
	"./lk.svg": 9128,
	"./lr.svg": 6753,
	"./ls.svg": 8304,
	"./lt.svg": 9423,
	"./lu.svg": 6846,
	"./lv.svg": 8941,
	"./ly.svg": 666,
	"./ma.svg": 5937,
	"./mc.svg": 7443,
	"./md.svg": 7260,
	"./me.svg": 6733,
	"./mf.svg": 2558,
	"./mg.svg": 6287,
	"./mh.svg": 9688,
	"./mk.svg": 427,
	"./ml.svg": 4308,
	"./mm.svg": 6917,
	"./mn.svg": 5046,
	"./mo.svg": 8871,
	"./mp.svg": 2016,
	"./mq.svg": 7969,
	"./mr.svg": 7602,
	"./ms.svg": 2771,
	"./mt.svg": 8876,
	"./mu.svg": 7821,
	"./mv.svg": 9470,
	"./mw.svg": 7903,
	"./mx.svg": 5016,
	"./my.svg": 9257,
	"./mz.svg": 1146,
	"./na.svg": 1240,
	"./nc.svg": 7370,
	"./ne.svg": 7924,
	"./nf.svg": 1047,
	"./ng.svg": 3510,
	"./ni.svg": 1920,
	"./nl.svg": 8493,
	"./no.svg": 9374,
	"./np.svg": 7657,
	"./nr.svg": 4747,
	"./nu.svg": 1684,
	"./nz.svg": 496,
	"./om.svg": 2600,
	"./pa.svg": 7182,
	"./pe.svg": 1074,
	"./pf.svg": 6113,
	"./pg.svg": 3872,
	"./ph.svg": 439,
	"./pk.svg": 6551,
	"./pl.svg": 1995,
	"./pm.svg": 4154,
	"./pn.svg": 8553,
	"./pr.svg": 9389,
	"./ps.svg": 9676,
	"./pt.svg": 3715,
	"./pw.svg": 9168,
	"./py.svg": 758,
	"./qa.svg": 538,
	"./re.svg": 7832,
	"./ro.svg": 5746,
	"./rs.svg": 2758,
	"./ru.svg": 3160,
	"./russia.svg": 8180,
	"./rw.svg": 7354,
	"./sa.svg": 3643,
	"./sb.svg": 5576,
	"./sc.svg": 4585,
	"./sd.svg": 5174,
	"./se.svg": 503,
	"./sg.svg": 6949,
	"./sh.svg": 5602,
	"./si.svg": 9331,
	"./sj.svg": 8320,
	"./sk.svg": 2705,
	"./sl.svg": 1150,
	"./sm.svg": 5791,
	"./sn.svg": 6764,
	"./so.svg": 4125,
	"./spain.svg": 5762,
	"./sr.svg": 248,
	"./ss.svg": 6265,
	"./st.svg": 9430,
	"./sv.svg": 8084,
	"./sx.svg": 8162,
	"./sy.svg": 1475,
	"./sz.svg": 2080,
	"./ta.svg": 810,
	"./tc.svg": 4680,
	"./td.svg": 3863,
	"./tf.svg": 1909,
	"./tg.svg": 740,
	"./th.svg": 2435,
	"./tj.svg": 7633,
	"./tk.svg": 1680,
	"./tl.svg": 7567,
	"./tm.svg": 9134,
	"./tn.svg": 7485,
	"./to.svg": 8540,
	"./tr.svg": 4745,
	"./tt.svg": 8535,
	"./tv.svg": 6581,
	"./tw.svg": 3972,
	"./tz.svg": 5601,
	"./ua.svg": 3513,
	"./ug.svg": 9895,
	"./um.svg": 9341,
	"./un.svg": 3070,
	"./us.svg": 891,
	"./uy.svg": 9953,
	"./uz.svg": 2850,
	"./va.svg": 5552,
	"./vc.svg": 2258,
	"./ve.svg": 3996,
	"./vg.svg": 4094,
	"./vi.svg": 8520,
	"./vn.svg": 6119,
	"./vu.svg": 236,
	"./wf.svg": 6936,
	"./ws.svg": 9493,
	"./xk.svg": 4892,
	"./xx.svg": 6511,
	"./ye.svg": 1545,
	"./yt.svg": 8184,
	"./za.svg": 6428,
	"./zm.svg": 5240,
	"./zw.svg": 7826
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8281;